import axios from 'axios';
import { generate } from '../util/AuthHeader';

class APIService {
  constructor() {
    this.api = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
    });
  }

  getCredentials() {
    const credentials = JSON.parse(localStorage.getItem('user'));
    const { accessKey, secretKey } = credentials;
    return { accessKey, secretKey };
  }

  async call(endpoint, method, payload = '<BLANK>', config = {}) {
    if (endpoint.includes('public')) {
      try {
        const response =
          method === 'GET'
            ? await this.api.get(endpoint, config)
            : await this.api.post(endpoint, payload, config);
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    }

    let credentials = this.getCredentials();

    try {
      let response;
      const encryptedPayload = generate(
        `${method}|${endpoint}`,
        credentials.secretKey,
        payload !== '<BLANK>' ? JSON.stringify(payload) : payload,
      );
      // set headers
      this.api.defaults.headers.common['X-AUTH-HEADER'] = encryptedPayload;
      this.api.defaults.headers.common['X-ACCESS-KEY'] = credentials.accessKey;

      console.log(encryptedPayload);

      if (method === 'POST') {
        // encrypt payload

        response = await this.api.post(endpoint, payload, config);
      } else {
        response = await this.api.get(endpoint, config);
      }
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default new APIService();
